import { render, staticRenderFns } from "./GetReaderOption.vue?vue&type=template&id=720d8804&scoped=true&"
import script from "./GetReaderOption.vue?vue&type=script&lang=ts&"
export * from "./GetReaderOption.vue?vue&type=script&lang=ts&"
import style0 from "./GetReaderOption.vue?vue&type=style&index=0&id=720d8804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d8804",
  null
  
)

export default component.exports